import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import classnames from 'classnames'
import { HostedField, Braintree } from 'react-braintree-fields'
import dispatchSelector from 'reduxModules/forms/paymentMethod/dispatchers'
import stateSelector from 'reduxModules/forms/paymentMethod//selectors'
import FieldError from './FieldError'
import getCardIcon from '../../utils/getCardIcon'
import keyUpHandler from '../../utils/keyUpHandler'
import { SLATE } from '../../../global/assets/styles/vars'
import './styles.css'

export class PaymentMethodForm extends Component {
  componentWillUnmount() {
    // some iOS devices does not close the keyboard after closing the form.
    document.activeElement.blur()
  }
  render() {
    if (this.props.clientToken === '' && !this.props.showForm) return null
    return (
      <div id="PaymentMethodForm">
        <div>
          <div
            className={classnames('form', { selected: this.props.payWithCreditCard })}
            aria-label="Choose to pay with credit card"
            onClick={() => this.props.choosePayWithCreditCard()}
            onKeyUp={event => keyUpHandler(event, this.props.choosePayWithCreditCard)}
            tabIndex="0"
          >
            {this.props.enablePaypal && (
              <div className="pay-with-card">
                <input
                  aria-label="Pay with credit card"
                  checked={this.props.payWithCreditCard}
                  name="paypal"
                  type="radio"
                  readOnly
                />
                <span>Credit Card</span>
              </div>
            )}
            <div className="card-type">
              <img
                src={getCardIcon(this.props.type)}
                alt={this.props.type}
              />
            </div>
            <Braintree
              authorization={this.props.clientToken}
              getTokenRef={t => this.props.storeTokenizer(t)}
              onCardTypeChange={this.props.cardTypeChanged}
              styles={{
                input: {
                  color: SLATE
                }
              }}
            >
              <div className="payment-container">
                <div className="payment-fields">
                  <div>
                    <HostedField
                      type="number"
                      className="hosted-field number"
                      placeholder="1234 1234 1234 1234"
                    />
                    <FieldError
                      show={_.includes(this.props.invalidFields, 'number')}
                      type="credit card number"
                    />
                  </div>
                  <div className="mobile-grouping">
                    <HostedField
                      type="expirationDate"
                      className="hosted-field expiration-date"
                      placeholder="MM / YY"
                    />
                    <FieldError
                      show={_.includes(this.props.invalidFields, 'expirationDate')}
                      type="expiration date"
                    />

                    <HostedField
                      type="cvv"
                      className="hosted-field cvv"
                      placeholder="Security Code"
                    />
                    <FieldError
                      show={_.includes(this.props.invalidFields, 'cvv')}
                      type="cvv"
                    />
                  </div>
                </div>
                {this.props.enableStoreMethodOption && (
                  <div className="optional-saving">
                    <input
                      id="save-payment-method-check"
                      type="checkbox"
                      value={this.props.storeMethod}
                      checked={this.props.storeMethod}
                      onChange={() => this.props.toggleStorePayment()}
                    />
                    <label
                      tabIndex="0"
                      onKeyUp={(event) => keyUpHandler(event, this.props.toggleStorePayment)}
                      htmlFor="save-payment-method-check"
                      onClick={() => this.props.toggleStorePayment()}
                    >
                      Save new payment method
                    </label>
                  </div>
                )}
              </div>
            </Braintree>
          </div>
          {this.props.enablePaypal && (
            <div
              className={classnames('paypal', { selected: !this.props.payWithCreditCard })}
              aria-label="Choose to pay with PayPal"
              onClick={() => this.props.choosePayWithPaypal()}
              onKeyUp={event => keyUpHandler(event, this.props.choosePayWithPaypal)}
              tabIndex="0"
            >
              <div className="inner-container">
                <div className="option">
                  <input
                    aria-label="Pay with Paypal"
                    checked={!this.props.payWithCreditCard}
                    name="paypal"
                    type="radio"
                    readOnly
                  />
                  <span>PayPal</span>
                </div>
                <div className="icon">
                  <img src="https://assets.braintreegateway.com/payment_method_logo/paypal.png" alt="paypal" />
                </div>
              </div>
            </div>
          )}
          <div className="buttons-container">
            <div className="secure-payment">
              <img src="/global/assets/images/icons/securePayment.svg" className="secure-payment-icon" alt="secure payment" />
              <span>secure payment</span>
            </div>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

PaymentMethodForm.propTypes = {
  cardTypeChanged: PropTypes.func.isRequired,
  savePaymentMethod: PropTypes.func,
  errorMessage: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  clientToken: PropTypes.string.isRequired,
  showForm: PropTypes.bool.isRequired,
  enablePaypal: PropTypes.bool,
  payWithCreditCard: PropTypes.bool
}

PaymentMethodForm.defaultProps = {
  enablePaypal: false,
  payWithCreditCard: true,
  savePaymentMethod: null
}

export default connect(stateSelector, dispatchSelector)(PaymentMethodForm)
